import {API_BASE} from "./reports";
import buildHeaders from './fetchHeaders';

/**
 * Create a source package item (folder or document fragment) in another product.
 * Used only for cross-product operations where the target product's Y.Doc is not
 * available locally — all same-product writes go through sourcePackageYMap.
 *
 * @param {string} productId - Target product (report) ID
 * @param {object} item
 * @param {'FOLDER'|'DOCUMENT_FRAGMENT'} item.type
 * @param {number|null} [item.parentFolderId]
 * @param {object} item.entity - Folder or fragment data
 * @param {string} [item.userId]
 */
export async function createSourcePackageItem(productId, item) {
    const response = await fetch(`${API_BASE}/products/${productId}/source-package/items`, {
        method: 'POST',
        headers: buildHeaders({
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        }),
        body: JSON.stringify(item),
    });

    if (!response.ok) {
        let message = 'Failed to create source package item';
        try {
            const errText = await response.text();
            if (errText) message += `: ${errText}`;
        } catch (_) {
        }
        throw new Error(message);
    }

    return await response.json();
}

/**
 * Get source package summary (analyzes against ICR)
 * @param {string} reportId
 * @param {object} icr - Structured ICR object
 * @param {string} userId - User ID for tracking
 * @param {string[]} [segmentIds] - Source package segment IDs to scope analysis
 */
export async function getSourcePackageSummary(reportId, icr, userId, segmentIds = []) {
    const response = await fetch(`${API_BASE}/source-package/summary`, {
        method: 'POST',
        headers: buildHeaders({
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        }),
        body: JSON.stringify({
            icr,
            userId,
            segmentIds,
        }),
    });

    if (!response.ok) {
        let message = 'Failed to get source package summary';
        try {
            const errText = await response.text();
            if (errText) message += `: ${errText}`;
        } catch (_) {
        }
        throw new Error(message);
    }

    return await response.json();
}
